import qs from 'query-string';
import {generateRoutePath} from '@epic-core/common';
import {History, Location} from 'history';

export const parseLocationQuery = <T extends object>(location: Location): T => {
    if (!location) return null;
    let query;
    try {
        query = qs.parse(location.search, {
            parseBooleans: true,
            parseNumbers: true
        });
    } catch (err) {
        console.warn('Unable to parse page');
    }
    return query || {};
};

/**
 * Trigger's pixel pageView
 * @param query {object}
 * @param url {string}
 */
export const updateBrowserHistory = async <T extends Record<string, any>>(
    history: History,
    query: T,
    url?: string
) => {
    if (!history) return;
    const locationUrl = url || history.location.pathname;
    history.replace(
        qs.stringifyUrl({
            url: generateRoutePath(locationUrl),
            query
        }),
        {
            skipScroll: true
        }
    );
};
